/* 全站回到顶部按钮（snippets/auxito-to-top.liquid）
   - 滚动超过约一屏后出现；外圈显示阅读进度。
   - 位置：有 Gorgias 聊天按钮时对齐在它正上方（同一中心线）；PDP 悬浮购买栏出现时再上移，不压住购买按钮。
   - 购物车抽屉 / 手机菜单等锁住页面滚动、聊天窗口展开时隐藏。
   - 点击平滑回顶（reduced-motion 直接跳）；键盘触发时把焦点交给页头，方便继续操作。
   性能：滚动帧里只读 scrollY 和几个 class（不读布局、不取计算样式），只写变化了的值；
   读布局的位置计算放在「出现时 / 窗口变化 / 页面结构变化 / 按钮可见期间每秒一次」，页面在后台时不跑。 */
(function () {
  'use strict';

  var btn = document.querySelector('[data-auxito-totop]');
  if (!btn || btn.dataset.auxitoTotopReady) return;
  btn.dataset.auxitoTotopReady = '1';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var GAP = 12;
  /* Gorgias 聊天按钮的固定位置（iframe 中心距视口右边、顶部距视口底部；PC / 手机实测）。
     聊天脚本加载得晚：按钮先出现时就按这个位置预留在它上方，聊天按钮出来后不会再跳。 */
  var CHAT_SLOT = { pc: { center: 60, top: 194 }, m: { center: 55, top: 184 } };
  var CHAT_WAIT_MS = 20000;

  var chatSeen = false;
  var chatOpen = false;
  var locked = false;
  var visible = false;
  var stickyOn = false;
  var maxScroll = 1;
  var lastRight = '';
  var lastBottom = '';
  var lastProgress = '';
  var scrollTicking = false;
  var layoutTicking = false;
  var launchTimer = 0;

  function isMobile() {
    return window.innerWidth <= 749;
  }

  function size() {
    return isMobile() ? 44 : 52;
  }

  function now() {
    return window.performance && performance.now ? performance.now() : 0;
  }

  function shown(el) {
    if (!el) return null;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) return null;
    var r = el.getBoundingClientRect();
    if (r.width < 4 || r.height < 4) return null;
    if (r.bottom <= 0 || r.top >= window.innerHeight) return null;
    return r;
  }

  /* 本页是否装了 Gorgias 聊天：Shopify 把 app 脚本地址写在内联脚本里（config.gorgias.chat/bundle-loader），只查一次并缓存 */
  var chatInstalled = null;
  function chatOnPage() {
    if (chatInstalled !== null) return chatInstalled;
    chatInstalled = false;
    var scripts = document.scripts;
    for (var i = 0; i < scripts.length; i += 1) {
      var src = scripts[i].src || '';
      if (src.indexOf('gorgias.chat') !== -1 || (!src && (scripts[i].textContent || '').indexOf('gorgias.chat') !== -1)) {
        chatInstalled = true;
        break;
      }
    }
    return chatInstalled;
  }

  /* 聊天按钮暂时不在（还没加载 / 收起动画中）时，是否仍按它的位置预留：
     本页把聊天藏掉（车型原型页 .ap2、容器 display:none）→ 不预留；本页装了聊天或出现过聊天按钮 → 预留；都查不到时只在页面打开 20 秒内预留 */
  function chatExpected() {
    if (document.querySelector('.ap2, .ap2or')) return false;
    var container = document.getElementById('gorgias-chat-container');
    if (container && window.getComputedStyle(container).display === 'none') return false;
    if (chatSeen || container || chatOnPage()) return true;
    return now() < CHAT_WAIT_MS;
  }

  /* 便宜的锁滚动判断（只看 class / 行内样式），滚动帧里用 */
  function quickLocked() {
    var b = document.body;
    if (!b) return false;
    return b.classList.contains('scroll-lock') || b.style.position === 'fixed' || b.style.overflow === 'hidden' || root.style.overflow === 'hidden';
  }

  /* 完整判断（含计算样式），只在布局检查里用 */
  function fullLocked() {
    var b = document.body;
    if (!b) return false;
    if (quickLocked() || document.querySelector('.auxito-cart-drawer.visible')) return true;
    return window.getComputedStyle(root).overflowY === 'hidden' || window.getComputedStyle(b).overflowY === 'hidden';
  }

  function setVar(name, value, last) {
    if (value === last) return last;
    btn.style.setProperty(name, value);
    return value;
  }

  /* 读布局：位置、聊天状态、锁滚动、页面可滚高度 */
  function measure() {
    layoutTicking = false;
    var s = size();
    var vw = root.clientWidth || window.innerWidth; /* 不含滚动条，和 position:fixed 的 right 同一基准 */
    var vh = window.innerHeight;
    var right = isMobile() ? 16 : 32;
    var bottom = isMobile() ? 20 : 32;

    var bubble = shown(document.getElementById('chat-button'));
    var chatWindow = shown(document.getElementById('chat-window'));
    chatOpen = !!(chatWindow && chatWindow.height > 160);
    if (bubble && bubble.height <= 140) {
      chatSeen = true;
      var cx = bubble.left + bubble.width / 2;
      right = Math.max(8, Math.round(vw - cx - s / 2));
      bottom = Math.round(vh - bubble.top + GAP);
    } else if (chatExpected()) {
      var slot = isMobile() ? CHAT_SLOT.m : CHAT_SLOT.pc;
      right = Math.max(8, slot.center - s / 2);
      bottom = slot.top + GAP;
    }

    /* PDP 悬浮购买栏（整宽贴底）：按钮至少在它上方 */
    var barEl = document.querySelector('#stickyBottomBar.is-visible');
    stickyOn = !!barEl;
    var bar = shown(barEl);
    if (bar && bar.top > vh * 0.4) {
      bottom = Math.max(bottom, Math.round(vh - bar.top + GAP));
    }

    lastRight = setVar('--totop-right', right + 'px', lastRight);
    lastBottom = setVar('--totop-bottom', bottom + 'px', lastBottom);

    var scroller = document.scrollingElement || root;
    maxScroll = Math.max(1, scroller.scrollHeight - vh);
    locked = fullLocked();
    onScroll();
  }

  function scheduleMeasure() {
    if (layoutTicking) return;
    layoutTicking = true;
    window.requestAnimationFrame(measure);
  }

  /* 滚动帧：只读 scrollY 与 class，不读布局 */
  function onScroll() {
    scrollTicking = false;
    var y = window.pageYOffset || 0;
    var pct = Math.min(1, Math.max(0, y / maxScroll));
    lastProgress = setVar('--totop-progress', String(Math.round((1 - pct) * 100)), lastProgress);

    /* 悬浮购买栏随滚动出现 / 消失：变化时补一次位置计算 */
    if (!!document.querySelector('#stickyBottomBar.is-visible') !== stickyOn) scheduleMeasure();

    var threshold = Math.max(480, window.innerHeight * 0.9);
    var next = y > threshold && !chatOpen && !locked && !quickLocked();
    if (next === visible) return;
    visible = next;
    if (visible) scheduleMeasure(); /* 出现前确认位置 */
    btn.classList.toggle('is-visible', visible);
    btn.tabIndex = visible ? 0 : -1;
    if (!visible && document.activeElement === btn) btn.blur();
  }

  function scheduleScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(onScroll);
  }

  /* 键盘回顶后把焦点交给页头里第一个看得见的链接（优先 Logo；手机菜单按钮在桌面是隐藏的，不能选它） */
  function focusTop() {
    var candidates = document.querySelectorAll('.site-logo a[href], a.site-logo[href], #shopify-section-static-header a[href], header a[href]');
    for (var i = 0; i < candidates.length; i += 1) {
      var el = candidates[i];
      if (!el.getClientRects().length || window.getComputedStyle(el).visibility === 'hidden') continue;
      try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
      if (document.activeElement === el) return;
    }
  }

  btn.addEventListener('click', function (event) {
    var viaKeyboard = event.detail === 0;
    var smooth = !reduceMotion.matches;

    btn.classList.remove('is-launching');
    void btn.offsetWidth; /* 重新触发发射动画 */
    btn.classList.add('is-launching');
    window.clearTimeout(launchTimer);
    launchTimer = window.setTimeout(function () { btn.classList.remove('is-launching'); }, 460);

    try {
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
    } catch (e) {
      window.scrollTo(0, 0);
    }

    if (viaKeyboard) {
      if (!smooth) {
        focusTop();
      } else {
        var waited = 0;
        var poll = window.setInterval(function () {
          waited += 100;
          if ((window.pageYOffset || 0) < 4 || waited > 3000) {
            window.clearInterval(poll);
            focusTop();
          }
        }, 100);
      }
    }
  });

  window.addEventListener('scroll', scheduleScroll, { passive: true });
  window.addEventListener('resize', scheduleMeasure, { passive: true });
  window.addEventListener('pageshow', scheduleMeasure);
  window.addEventListener('load', scheduleMeasure);

  /* 抽屉 / 菜单开关只改 class 或 style、购物车抽屉是插到 body 下的节点：监听 html、body 自身属性与 body 直接子节点（不监听整棵子树） */
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(scheduleMeasure);
    mo.observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
    if (document.body) mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'], childList: true });
  }

  /* 聊天按钮 / 购物车抽屉 / 优惠条会异步出现或移动：按钮可见（或被锁隐藏）期间每秒对齐一次；页面在后台或按钮本就不需要时不读布局 */
  window.setInterval(function () {
    if (document.hidden) return;
    if (visible || locked || chatOpen) scheduleMeasure();
  }, 1000);

  scheduleMeasure();
})();
